import { useState, useEffect } from "react";
import { EditPatientModal } from "./EditPatientModal";

const DetailSection = ({ title, details, fields }) => (
  <div className="py-4">
    <h3 className="text-base text-[#5D5D5D] mb-4">{title}</h3>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {Object.entries(fields).map(([key, label]) => (
        <div key={key}>
          <label className="block text-sm font-medium text-black">
            {label}
          </label>
          <p className="text-sm text-[#4F4F4F]">{details[key]}</p>
        </div>
      ))}
    </div>
  </div>
);

export const PatientDetails = ({
  details,
  patientId,
  onRefresh,
  openEditModal,
}) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  useEffect(() => {
    if (openEditModal) {
      setIsEditModalOpen(true);
    }
  }, [openEditModal]);
  const personalInfoFields = {
    dob: "Date of Birth",
    mobile: "Mobile Number",
    email: "Email",
    weight: "Weight",
    height: "Height",
  };

  const paymentMethodFields = {
    paymentMethod: "Payment Method",
    cardName: "Name on Card",
    expiresOn: "Expires On",
  };

  const billingInfoFields = {
    country: "Country",
    state: "State",
    city: "City",
    houseAddr: "House address",
    zipCode: "Zip code",
  };

  return (
    <div className="mt-6 divide-y divide-gray-200">
      <div className="py-4">
        <h3 className="text-base text-[#5D5D5D] mb-4">Personal Information</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex items-center gap-3 mt-1">
            <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white font-semibold text-sm">
              {details.name.charAt(0).toUpperCase()}
            </div>
            <div className="">
              <label className="block text-sm font-medium text-black">
                Name
              </label>
              <p className="text-sm text-[#4F4F4F]">{details.name}</p>
            </div>
          </div>
          {Object.entries(personalInfoFields).map(([key, label]) => (
            <div key={key}>
              <label className="block text-sm font-medium text-black">
                {label}
              </label>
              <p className="text-sm text-[#4F4F4F] mt-1">{details[key]}</p>
            </div>
          ))}
        </div>
      </div>

      <DetailSection
        title="Payment Method"
        details={details}
        fields={paymentMethodFields}
      />
      <DetailSection
        title="Billing Information"
        details={details}
        fields={billingInfoFields}
      />

      <EditPatientModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        patientId={patientId}
        onSuccess={() => {
          setIsEditModalOpen(false);
          if (onRefresh) onRefresh();
        }}
      />
    </div>
  );
};
